export const state = initialState();

export const actions = {
  getStatistics: async ({ commit }) => {
    const data = [
      {
        clazz: 'StatisticCounter',
        id: 3,
        enabled: false,
        farmId: 8,
        elementId: null,
        count: 811,
        icon: 'accessibility'
      },
      {
        clazz: 'StatisticCounter',
        id: 4,
        enabled: false,
        farmId: 8,
        elementId: null,
        count: 8,
        icon: 'accessibility'
      },
      {
        clazz: 'ChartData',
        id: null,
        enabled: false,
        values: [
          {
            clazz: 'ChartItem',
            id: null,
            enabled: false,
            label: 'Sep',
            value: 19
          },
          {
            clazz: 'ChartItem',
            id: null,
            enabled: false,
            label: 'Oct',
            value: 9
          },
          {
            clazz: 'ChartItem',
            id: null,
            enabled: false,
            label: 'Nov',
            value: 7
          },
          {
            clazz: 'ChartItem',
            id: null,
            enabled: false,
            label: 'Dec',
            value: 1
          },
          {
            clazz: 'ChartItem',
            id: null,
            enabled: false,
            label: 'Jan',
            value: 0
          },
          {
            clazz: 'ChartItem',
            id: null,
            enabled: false,
            label: 'Feb',
            value: 8
          }
        ]
      },
      {
        clazz: 'StatisticCounter',
        id: 1,
        enabled: false,
        farmId: 8,
        elementId: null,
        count: 24,
        icon: 'archive'
      },
      {
        clazz: 'StatisticCounter',
        id: 2,
        enabled: false,
        farmId: 8,
        elementId: null,
        count: 0,
        icon: 'archive'
      },
      {
        clazz: 'ChartData',
        id: null,
        enabled: false,
        values: null
      }
    ];

    commit('mutateStatistics', data);
  },
  getConversionSuccess: async ({ commit }) => {
    const data = {
      headers: [
        {
          text: 'Location',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Views', value: 'views' },
        { text: 'Sales', value: 'sales' },
        { text: 'Conversion', value: 'conversion' }
      ],
      locations: [
        {
          name: 'Agave Heritage Festival',
          views: 3746,
          sales: 752,
          conversion: 0.2
        },
        {
          name: 'Breads of the Creative Cities',
          views: 8126,
          sales: 728,
          conversion: 0.09
        },
        {
          name: 'Ranchers & Farmers',
          views: 8836,
          sales: 694,
          conversion: 0.08
        },
        {
          name: 'Days of Silk',
          views: 1173,
          sales: 645,
          conversion: 0.55
        },
        {
          name: 'Days of Drums',
          views: 2739,
          sales: 539,
          conversion: 0.2
        },
        {
          name: 'Valmastallone',
          views: 1762,
          sales: 432,
          conversion: 0.24
        },
        {
          name: 'Patino Academia',
          views: 3746,
          sales: 752,
          conversion: 0.2
        }
      ]
    };
    commit('mutateConversionSuccess', data);
  },
  getQuickDetail: async ({ commit }) => {
    const data = [
      {
        name: 'New Customers',
        numberofUnits: 290,
        sourceOfInformation: 'Last 24 Hours'
      },
      {
        name: 'Engagements',
        numberofUnits: 490,
        sourceOfInformation: 'On Supply Chain Items'
      },
      {
        name: 'Conversion Rate',
        numberofUnits: '22%',
        sourceOfInformation: 'Avg Conversion Rate'
      },
      {
        name: 'Minutes',
        numberofUnits: 15,
        sourceOfInformation: 'Avg Time Spent Browsing'
      }
    ];
    commit('mutateQuickDetail', data);
  },
  getKPIS: async ({ commit }) => {
    const data = [
      {
        name: 'Total Unique Visitors',
        value: '12.45K',
        icon: 'group'
      },
      {
        name: 'Engagement Rate',
        value: '5.6%',
        icon: 'question_answer'
      },
      {
        name: 'Monthly Follower Growth',
        value: '-6%',
        icon: 'trending_up'
      },
      {
        name: 'Monthly Reach',
        value: '250',
        icon: 'settings_input_antenna'
      }
    ];

    commit('mutateKPIS', data);
  }
};

export const mutations = {
  mutateStatistics: (state, payload) => {
    state.chartValues = payload[2].values;
    state.chartTitle = payload[2].clazz;
    state.pieChartUnit = 'Fake Unit';
  },
  mutateConversionSuccess: (state, payload) => {
    (state.headers = payload.headers),
      (state.locations = payload.locations),
      (state.tableTitle = 'Conversion Success');
  },
  mutateQuickDetail: (state, payload) => {
    state.quickDetail = payload;
  },
  mutateKPIS: (state, payload) => {
    state.quickStats = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    chartValues: [],
    chartTitle: '',
    pieChartUnit: '',
    headers: [],
    locations: [],
    tableTitle: '',
    quickDetail: [],
    quickStats: []
  };
}
